import { render, staticRenderFns } from "./ForgotPw_post_request.vue?vue&type=template&id=c7904ed0&scoped=true&"
import script from "./ForgotPw_post_request.vue?vue&type=script&lang=js&"
export * from "./ForgotPw_post_request.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPw_post_request.vue?vue&type=style&index=0&id=c7904ed0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7904ed0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VForm,VSelect,VTextField})
